import React from 'react';
import PropTypes from 'prop-types';
import constants from '../../qti/Constants';
import presignUrlService from '../../services/PresignUrlService';
import questionHelperService from '../../services/questionView/QuestionHelperServices';
import styles from './additionalResourcesBar.scss';
import { t } from '../../services/i18nService';

class AdditionalResource extends React.PureComponent {
    static propTypes = {
        url: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
    };

    openUrl = (e) => {
        e.preventDefault();
        const { url, type } = this.props;
        if (type === constants.additionalResourceType.FILE) {
            presignUrlService.loadPresignedUrl(url, url)
                .then((presignedUrl) => {
                    const pdfJsService = questionHelperService.getServices().pdfJsService;
                    const previewURL = pdfJsService.getPdfJsUrl(presignedUrl);
                    window.open(previewURL, '_blank');
                });
        } else {
            window.open(url, '_blank');
        }
    };

    render() {
        const { title, type } = this.props;
        let icon;
        let rel;

        switch (type) {
        case constants.additionalResourceType.FILE:
            // If opening file it is PDF and then pass opener to allow error tracking back to player
            icon = 'fa-file';
            rel = 'opener';
            break;

        case constants.additionalResourceType.RUBRIC:
            icon = 'fa-th-large';
            rel = 'noopener noreferrer';
            break;

        default:
            icon = 'fa-globe';
            rel = 'noopener noreferrer';
            break;
        }

        return (
            <li>
                <button
                    role="link"
                    onClick={this.openUrl}
                    className={styles.resourceButton}
                    rel={rel}
                    aria-label={`${title} (${t('general.opensInNewWindow')})`}
                >
                    <i className={`fa ${icon}`} aria-hidden="true" />
                    { title }

                    <i className={`fa fa-external-link ${styles.external}`} aria-hidden="true" />
                </button>
            </li>
        );
    }
}

export default AdditionalResource;
